var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      !_vm.link
        ? _c(
            "button",
            {
              staticClass:
                "btn-gradient shadow text-white leading-tight text-center text-sm uppercase block w-full rounded focus:outline-none px-4 py-3 font-bold",
              class: _vm.btnClass,
              attrs: {
                type: _vm.type ? _vm.type : "submit",
                disabled: _vm.disabled,
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("click")
                },
              },
            },
            [_c("span", { staticClass: "m-auto" }, [_vm._t("default")], 2)]
          )
        : _vm._e(),
      _vm.link
        ? _c(
            "router-link",
            {
              staticClass:
                "btn-gradient shadow text-white leading-tight text-center text-sm uppercase block w-full rounded focus:outline-none px-4 py-3 font-bold",
              class: _vm.btnClass,
              attrs: { to: _vm.link },
            },
            [_vm._t("default")],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }